import { compose } from 'recompose'
import EkycDocumentFooter from 'e-submission/components/Card/EkycDocumentFooter'

const Component = (props) => <EkycDocumentFooter {...props} />

export default (hoc) => compose(hoc)(Component)
